// extracted by mini-css-extract-plugin
export default {"wrapper":"categories_wrapper__sscly","rounded":"categories_rounded__n8nTn","category":"categories_category__acZxk","clearButton":"categories_clearButton__YYaFt"};